import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ModalComponent } from '@geekbears/ngx-gb-ui-kit';

@Component({
  selector: 'app-profile-modals',
  templateUrl: './profile-modals.modal.html',
  styleUrls: ['./profile-modals.modal.scss'],
})
export class ProfileModals extends ModalComponent implements OnInit {
  modalType: string = '';
  constructor(
    private router: Router,
    @Inject(MAT_DIALOG_DATA) data: any,
    private dialogRef: MatDialog
  ) {
    super();
    if (data) {
      this.modalType = data.type;
    }
  }

  ngOnInit(): void {}

  backToProfile() {
    this.closeModal();
    this.router.navigateByUrl('dashboard/profile');
  }
  closeModal() {
    this.dialogRef.closeAll();
  }
}
